import { Button, useTheme } from '@mui/material'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'

type PostCreateConfirmModalProps = {
  open: boolean
  onClose: () => void
  onClick: () => void
  loading: boolean
}
export const PostCreateConfirmModal = ({
  open,
  onClose,
  onClick,
  loading,
}: PostCreateConfirmModalProps) => {
  const { t } = useTranslation('consolePostCreate')
  const { zIndex } = useTheme()

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('confirmCreateTitle')}
      content={t('confirmCreateMessage')}
      buttons={
        <Button
          size="large"
          sx={{ width: 212 }}
          onClick={onClick}
          loading={loading}
          disabled={loading}
        >
          {t('toPost')}
        </Button>
      }
      cancelText={t('cancel')}
      sx={{
        zIndex: zIndex.modal + 2,
      }}
    />
  )
}
